import { createContext } from 'react';

import {
  EventSummary,
  EventTotalsInput,
} from '@totem/components/services/threats/totals/types';

interface Context {
  input: EventTotalsInput;
  setInput: (input: EventTotalsInput) => void;
  loading: boolean;
  data: EventSummary;
  action: string;
  onAction?: (action: string) => void;
}

export default createContext<Context>({
  input: {},
  setInput: () => {},
  loading: false,
  data: null,
  action: '',
  onAction: () => {},
});
